import 'javascripts/layouts/v2/application'
import 'stylesheets/layouts/v2/application'
